// cell renderers specific to Submissions
import React from "react"
import { Badge } from "components-design-system"
import { registryContinentMap, FORM_VIEW_TRANSFORMER, FORM_SECTION_TRANSFORMER } from "../../../constants/submissions"
import "./SubmissionCellRenderers.scss"

import regionColorMap from "components-design-system/badges/regionColorMap" // FormsCellRenderer

/** Submission/Download History */

// will display N/A if download XML
const BooleanCellRenderer = ({ value, data }) => {
  const isXmlDownload = data.download_only
  let displayVal = ""
  if (value === undefined || isXmlDownload) {
    displayVal = "N/A"
  } else if (value && value === true) {
    displayVal = "Yes"
  } else if (value === false) {
    displayVal = "No"
  }
  return <div>{displayVal}</div>
}

// download_only
const TypeCellRenderer = (props) => {
  const { value } = props
  if (value === undefined) return <div></div>
  let returnVal = "Submission"
  if (value === true) returnVal = "Download"
  return <div>{returnVal}</div>
}

const FormsCellRenderer = ({ value }) => {
  if (!value || value?.length === 0) return null

  const getDisplayValue = (form) => {
    const view = FORM_VIEW_TRANSFORMER?.[form.form_view] || form.form_view || ""
    const section = FORM_SECTION_TRANSFORMER?.[form.form_section] || form.form_section || ""
    return `${view} ${section}`.trim()
  }

  const sortedForms = [...value]
    .filter((form) => registryContinentMap[form.form_view])
    .sort((a, b) => getDisplayValue(a).localeCompare(getDisplayValue(b)))

  return (
    <div className="submissions-forms-cell-renderer-container">
      {sortedForms.map((form) => {
        const displayValue = getDisplayValue(form)
        return (
          <Badge
            key={displayValue}
            value={displayValue}
            colorName={regionColorMap[registryContinentMap[form.form_view]]}
          />
        )
      })}
    </div>
  )
}

// form is an array of document type indeces
const UploadDocsCellRenderer = (props) => {
  const { value } = props
  if (!value || value?.length === 0) return <div>N/A</div>
  // TODO: map index values to document types
  // const displayVal = value.split(',');
  if (Array.isArray(value)) {
    return <div>{value?.join(", ")}</div>
  }

  return <div>{value}</div>
}

const LinkCellRenderer = ({ value }) => {
  if (!value) return <div>N/A</div>
  return (
    <div>
      <a
        href={value}
        target="_blank"
      >
        View
      </a>
    </div>
  )
}

export { BooleanCellRenderer, TypeCellRenderer, FormsCellRenderer, UploadDocsCellRenderer, LinkCellRenderer }
